import { Button, Input, message, Modal, Spin } from "antd";
import axios, { AxiosError } from "axios";
import { useContext, useState } from "react";
import { createGroupDocumentApi } from "../../axios/portalData";
import { getGroupAndMachineDocuments } from "../../Common/commonFunctions";
import GroupDocumentContext from "../../themeContext/GroupDocumentContext";
import GroupsMachinesReFetchFlagContext from "../../themeContext/GroupsMachinesReFetchFlagContext";
import MachineDocumentContext from "../../themeContext/MachineDocumentContext";

import "./createNewGroupPopup.less";

interface Props {
  visible: boolean;
  closeModal: (refresh?: boolean) => void;
  setGroups: React.Dispatch<React.SetStateAction<string[]>>;
  groups: string[];
  setSelectedGroup: React.Dispatch<React.SetStateAction<string | null>>;
}

const CreateNewGroupPopup: React.FC<Props> = (props) => {
  const { visible, closeModal, setGroups, groups, setSelectedGroup } = props;
  const [groupName, setGroupName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState<"" | "error" | "warning" | undefined>("");
  const { setGroupDocument } = useContext(GroupDocumentContext);
  const { setMachineDocuments } = useContext(MachineDocumentContext);
  const { setGroupsMachinesReFetchFlag } = useContext(GroupsMachinesReFetchFlagContext);

  const cancelClicked = () => {
    setGroupName("");
    setStatus("");
    closeModal();
  };

  const createNewGroupClicked = (newName: string) => {
    if (newName.length == 0) {
      setStatus("error");
      message.error("The group name cannot be empty");
    } else if (groups.includes(newName)) {
      setStatus("error");
      message.error("This group name already exists!");
    } else {
      setStatus("");
      // handle loading, run api here, then clear groupName and modal
      setIsLoading(true);
      const groupObject = {
        newGroupName: newName,
      };
      createGroupDocumentApi(groupObject)
        .then(function (response) {
          message.success("Your group has been added successfully", 5);
          const temp = Object.keys(response.groups);
          // re-orders the names so "None" is always at the top, otherwise it is alphabetical
          for (let i = 0; i < temp.length; i++) {
            if (temp[i] == "None") {
              temp.splice(i, 1);
            }
          }
          temp.unshift("None");
          setGroups(temp);
          getGroupAndMachineDocuments(setGroupDocument, setMachineDocuments, setGroupsMachinesReFetchFlag);
          setSelectedGroup(newName);
          setIsLoading(false);
          setGroupName("");
          closeModal(true);
        })
        .catch((error: Error | AxiosError) => {
          if (axios.isAxiosError(error)) {
            console.log("AxiosError message: ", error);
            message.error("Failed to create a group: " + error.message, 5);
          } else {
            console.log("unexpected error: ", error);
            message.error("Failed to create a group: " + error, 5);
          }
          setIsLoading(false);
          setGroupName("");
          closeModal();
        });
    }
  };

  return (
    <Modal
      // maskTransitionName bug:  https://github.com/ant-design/ant-design/issues/27192
      centered={true}
      visible={visible}
      footer={null}
      closable={false}
      wrapClassName="modal-wrapper"
      maskTransitionName=""
    >
      <div>
        {isLoading ? (
          <div style={{ textAlign: "center" }}>
            <Spin size="large" />
          </div>
        ) : (
          <div>
            <div className="new-group-title">Create new group</div>
            <div className="new-group-input-title">New group name</div>
            <Input
              status={status}
              className="new-group-input"
              placeholder={"Group name"}
              onChange={(e) => setGroupName(e.target.value)}
              value={groupName}
              onPressEnter={() => createNewGroupClicked(groupName)}
            />
            <div className="btn-grp-wrapper">
              <Button className="primary-button" onClick={cancelClicked}>
                Cancel
              </Button>
              <Button className="secondary-button" onClick={() => createNewGroupClicked(groupName)}>
                Create Group
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CreateNewGroupPopup;
